import { rainbowTextRevealAnimation } from '#app/components/ContraMagic/animations.js';
import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const BioTextRegular = styled(Text).attrs({ textStyle: 'bodyRegular' })<{
  $startRevealBioAnimation?: boolean;
}>`
  text-align: left;
  word-break: break-word;
  white-space: pre-wrap;

  ${({ $startRevealBioAnimation = false }) => css`
    ${$startRevealBioAnimation
      ? css`
          animation: ${rainbowTextRevealAnimation} 3s ease-in-out;
        `
      : undefined}
  `}
`;
